module.exports = __webpack_public_path__ + "static/media/Group 11552.5c7a188a.svg";